import { useTabsComponents } from '@/next/utils/useTabsComponents';
import { AnnotationGroup, LayerGroup, PhotoGroup } from '@/stores/viewer';
import { cn } from '@/utils/classname';
import { LayeringTab } from './LayeringTab';

export interface GroupSettingsMenuProps {
  layer: LayerGroup | AnnotationGroup | PhotoGroup;
}

export const GroupSettingsMenu = ({ layer }: GroupSettingsMenuProps) => {
  const { Tabs, TabsList, TabsTrigger, TabsContent } = useTabsComponents();

  return (
    <div className={cn('w-full', 'flex', 'flex-col')}>
      <Tabs defaultValue="layering">
        <TabsList>
          <TabsTrigger value="layering">Layering</TabsTrigger>
        </TabsList>
        <TabsContent value="layering">
          <LayeringTab layer={layer} />
        </TabsContent>
      </Tabs>
    </div>
  );
};
